export default __webpack_public_path__ + "static/media/14613-403239-15384.2b8abdb8.jpg";